import React from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const ConfirmTurnOffApkUpdateStatusDialog = ({
    open,
    setOpen,
    onConfirm,
    screen
}) => {
  const {t} = useTranslation()

  return (
    <Dialog
        open={open}
        onClose={() => setOpen({open: false, screen: null})}
        fullWidth
        maxWidth="sm"
    >
        <DialogContent>
            <DialogContentText>{t("views.redesignScreens.confirmTurnOffApkUpdateStatusTitle")}</DialogContentText>
            <Typography mt={2}>{t("views.redesignScreens.confirmTurnOffApkUpdateStatusContent")}</Typography>
            <Typography mt={2} fontWeight="600">{t("views.redesignScreens.confirmTurnOffApkUpdateStatusQuestion")}</Typography>
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" color="error" onClick={() => setOpen({open: false, screen: null})}>{t("views.redesignScreens.noCancel")}</Button>
            <Button variant="contained" color="success" onClick={() => onConfirm(screen)} >{t("views.redesignScreens.yesChange")}</Button>
        </DialogActions>
    </Dialog>
  )
}

export default ConfirmTurnOffApkUpdateStatusDialog
